let ctx;

function beep(ok) {
  try {
    ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
    const o = ctx.createOscillator();
    const g = ctx.createGain();
    const dur = ok ? 0.12 : 0.35;
    o.type = ok ? "sine" : "square";
    o.frequency.value = ok ? 1046 : 220;
    g.gain.setValueAtTime(0.08, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + dur);
    o.connect(g).connect(ctx.destination);
    o.start();
    o.stop(ctx.currentTime + dur);
  } catch (_) { /* audio unavailable */ }
}

export function scanFeedback(ok, label = "") {
  beep(ok);
  navigator.vibrate?.(ok ? 40 : [80, 60, 80]);
  window.dispatchEvent(new CustomEvent("sk-scan", { detail: { ok, label } }));
}
